// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6a8243ad","867":"4b6cf0f8"}[chunkId] + ".chunk.js";
};